



























































import Vue from 'vue';
import Component from 'vue-class-component'
import {ActiveUser, User} from '@/modules/auth/types'
import {State} from 'vuex-class'
import {Watch} from 'vue-property-decorator'
import ActiveUsers from '@/modules/auth/components/ActiveUsers.vue';
@Component({
    components: {ActiveUsers},
})
export default class UserMenu extends Vue {

    @State(state => state.auth.user)
    public user: User;

    @State(state => state.auth.activeUsers)
    public activeUsers: ActiveUser[]

    @State(state => state.auth.changingActiveUser)
    public changingActiveUser: boolean

    public changingUser = false

    public makingLogout = false
    public menu = false;

    public async logout () {
        this.makingLogout = true;
        await this.$store.dispatch('auth/logout');
        await this.$router.push({name: 'login'});
    }

    public get avatarText () {
        return this.user.name.split(' ').map(l => l.charAt(0)).join('')
    }

    /**
     * Observa la ruta actual, si esta cambia el menu es cerrado. Esto evita que el
     * menu tenga que ser cerrado manualmente por el usuario
     */
    @Watch('$route')
    public onRoute () {
        this.menu = false
    }

    /**
     * Seleccionar usuario activo
     *
     * Invocado cuando el usuario hace click sobre un de los usuarios de la lista. Si el usuario
     * seleccionado no se encuentra seleccionado se redirigirá a la pantalla de login para
     * volver a introducir las credenciales.
     *
     * Si el usuario si tiene token se cargará la configuración correspondiente y dicha cuenta
     * será establecida como actual de la aplicación
     *
     * @param user
     */
    public async selectActiveUser (user: ActiveUser) {
        this.$store.commit('auth/TOGGLE_CHANGING_ACTIVE_USER', true)
        // El usuario no tiene porque salio de la aplicación, debe autenticarse
        // de nuevo
        if (!user.token) {
            this.$store.commit('auth/TOGGLE_CHANGING_ACTIVE_USER', true)
            this.$store.commit('auth/SET_ACTIVE_USER_TO_BE_AUTHENTICATED', user)
            await this.$router.push({name: 'login'})

            return
        }

        this.changingUser = true
        await this.$store.dispatch('auth/changeActiveUser', user)
        this.$store.commit('auth/TOGGLE_CHANGING_ACTIVE_USER', false)

        this.changingUser = false
    }
}
